import { store } from '../../../../store.js';

const PRICE_PER_USER = 38.5;
const EXTRA_ZONE_PRICE = 38.5;
const NATIONAL_ZONE_PRICE = 0;

const EXTRA_ZONE_QUANTITY = 12;
const NATIONAL_ZONE_QUANTITY = 12;

const CATEGORY_COMMERCIAL_PRICE = 44;

const handleName = (packageName, userCount, isNational) => {
  return `${packageName} - ${userCount} ${userCount > 1 ? 'Users' : 'User'} - ${
    isNational ? 'National' : '1 Zone'
  }`;
};

const getPrice = (productPackage, discountedPercentage) => {
  const { productsConfig } = store.getState().packageSelection;
  const price = productsConfig['cordell-costings'].configuration.packages[productPackage].packagePrice
  if(discountedPercentage) {
    const discountedPrice = price * discountedPercentage
    const totalPrice = Math.round((price - discountedPrice) * 100)/100;
    return totalPrice;
  } else {
    return price;
  }

};

const handleCategory = (
  productList, 
  product, 
  packageName, 
  productCategory, 
  category_price, 
  discountPercentage
) => {
  if (productCategory.commercial) {
    product.item_id = product.item_name = `${packageName} - Add On - Category`;

    if(discountPercentage) {
      const discountedPrice = category_price * discountPercentage
      const totalPrice = Math.round((category_price - discountedPrice) * 100)/100;
      product.price = totalPrice;
    } else {
      product.price = category_price;
    }
    productList.push({ ...product });
  }
};

const handleExtraUser = (
  productList,
  product,
  packageName,
  userCount,
  defaultUserCount,
  pricePerUser,
  minimumInitialTerm,
  discountPercentage
) => {
  if (userCount > defaultUserCount) {
    const extraUserCount = userCount - defaultUserCount;

    product.item_id = product.item_name = `${packageName} - Add On - Extra User`;

    if(discountPercentage) {
      const discountedPrice = pricePerUser  * discountPercentage
      const totalPrice = Math.round((pricePerUser- discountedPrice) * 100)/100;
      product.price = totalPrice;
    } else {
      product.price = pricePerUser
    }
    product.quantity = minimumInitialTerm * extraUserCount;

    productList.push({ ...product });
  }
};

const handleExtraZone = (
  productList,
  product,
  packageName,
  isNational,
  states,
  nationalZonePrice,
  extraZonePrice,
  discountPercentage
) => {
  if (isNational || states.length > 1) {
    // extra zone yes for national || 2 zones
    product.item_id = product.item_name = `${packageName} - Add On - Extra Zone`;
    if(discountPercentage){
      const discountedPrice = (isNational ? nationalZonePrice : extraZonePrice) * discountPercentage
      const totalPrice = Math.round(((isNational ? nationalZonePrice : extraZonePrice) - discountedPrice) * 100)/100;
      product.price = totalPrice;
    }else{
      product.price = (isNational ? nationalZonePrice : extraZonePrice);
    }
    product.quantity = isNational ? NATIONAL_ZONE_QUANTITY : EXTRA_ZONE_QUANTITY;
    productList.push({ ...product });
  }
};

const handleCordellEstimatorConfig = (quote, quoteConfig, category) => {
  const { headLine: packageName, minimumInitialTerm } = quote;
  const {
    category: productCategory,
    geography,
    numberOfUsers: userCount,
    packageName: productPackage
  } = quoteConfig.configuration;

  let product = {};
  const productList = [];

  let defaultUserCount = 1;

  // Default Values
  product.item_brand = 'Cordell Estimator';
  product.item_category = category;
  product.item_variant = packageName;
  product.coupon = null;
  const discountPercentage = quote.provisioningInfo?.discountPercentage
    ? quote.provisioningInfo?.discountPercentage / 100
    : null;

  product.item_id = product.item_name = handleName(packageName, userCount, geography.national);
  product.price = getPrice(productPackage, discountPercentage);
  product.quantity = minimumInitialTerm;
  product.item_category2 = minimumInitialTerm.toString();
  product.item_category3 = geography.national ? 'National' : geography.states?.join(', ');

  productList.push({ ...product });

  // Handle Extra User (compare to defaultUserCount)
  handleExtraUser(
    productList,
    product,
    packageName,
    userCount,
    defaultUserCount,
    PRICE_PER_USER,
    minimumInitialTerm,
    discountPercentage
  );

  // Handle Extra Zone
  handleExtraZone(
    productList,
    product,
    packageName,
    geography.national,
    geography.states,
    NATIONAL_ZONE_PRICE,
    EXTRA_ZONE_PRICE,
    discountPercentage
  );

  handleCategory(productList, product, packageName, productCategory, CATEGORY_COMMERCIAL_PRICE);

  return productList;
};

export { handleCordellEstimatorConfig };
